
import { Prop } from 'vue-property-decorator'
import { Vue, Options } from 'vue-class-component'
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { isExactString } from '@/utils/object'
import { useStore } from '@/store'

library.add(faXmark)

@Options({
  components: {
    FontAwesomeIcon,
  },
})
export default class ModalBottomBarcode extends Vue {
  @Prop() onClose!: () => void
  store = useStore()
  clubcardNo = this.store.state.customer.clubcardNo!

  private active = true

  mounted() {
    this.setOpacity()
    this.generateBarcode()
    this.generateQRcode()
  }

  setOpacity() {
    const modalElement = document.getElementsByClassName(
      'dummy-background-barcode'
    )[0]! as HTMLElement
    setTimeout(() => {
      modalElement.style.opacity = '0.7'
    }, 10)
  }

  closeModal() {
    const dialogElement = document.getElementsByClassName(
      'modal-dialog-barcode'
    )[0]! as HTMLElement
    const modalElement = document.getElementsByClassName(
      'dummy-background-barcode'
    )[0]! as HTMLElement

    dialogElement.style.bottom = '-100%'
    modalElement.style.opacity = '0'

    setTimeout(() => {
      this.onClose()
    }, 500)
  }

  generateBarcode() {
    JsBarcode('#barCode', this.clubcardNo, {
      height: 73, 
      fontSize: 18,
      font: 'Lotuss Smart HL',
      margin: 0
    })
  }

  generateQRcode() {
    const qrCode = document.getElementById('qrCode') as HTMLElement
    QRCode.toCanvas(qrCode, this.clubcardNo, { margin: 2, scale: 1, width: 214 })
  }

  onClickOutside(event: any) {
    const elClassName = event.target.className
    if (isExactString(elClassName)) {
      if (elClassName.includes('modal-show-bar-qr-code')) {
        this.closeModal()
      }
    }
  }
}
